import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { getAnalytics, Analytics } from 'firebase/analytics';

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || '',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);

// Initialize Firebase Analytics (only in browser, not in emulator)
// getAnalytics is synchronous and safe to call - it will initialize if not already initialized
let analytics: Analytics | null = null;
if (typeof window !== 'undefined' && process.env.REACT_APP_FIREBASE_USE_EMULATOR !== 'true') {
    try {
        analytics = getAnalytics(app);
    } catch (error) {
        // Analytics initialization failed (e.g., in Node.js environment or unsupported browser)
        analytics = null;
    }
}

export { analytics };


// Connect to emulators in development
if (process.env.REACT_APP_FIREBASE_USE_EMULATOR === 'true') {
    try {
        // Connect to Auth emulator
        connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
        
        // Connect to Firestore emulator
        connectFirestoreEmulator(db, '127.0.0.1', 8080);
        
        // Connect to Functions emulator (if needed)
        connectFunctionsEmulator(functions, '127.0.0.1', 22223);
        
        //console.log('🔥 Connected to Firebase emulators');
    } catch (error) {
        console.warn('⚠️ Could not connect to Firebase emulators:', error);
    }
}

export default app; 